import { InjectionToken } from '@angular/core';
import { IHotkeyOptions } from "./hotkey.options";

export const HotkeyOptions = new InjectionToken<IHotkeyOptions>( 'HotkeyOptions' );